import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { IconUploads } from '../../assets/icons/iconUploads';
import {
    DropArea,
    DropIcon,
    DropTitle,
    DropDesc,
    DropCaption,
    FileCard,
    FileBadge,
    FileInfo,
    RemoveButton,
    RemoveSpinner,
} from './styles';

export const PLANILHA_MAX_SIZE = 3098486; // ~3MB

export const PLANILHA_ACCEPT = {
    'application/vnd.ms-excel': ['.xls'],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
    'text/csv': ['.csv'],
    'application/vnd.oasis.opendocument.spreadsheet': ['.ods'],
};

const formatSize = (bytes) => `${(bytes / 1024).toFixed(0)} KB`;

// Dropzone generico de arquivo unico. Os defaults sao os da planilha de importacao,
// entao quem ja usava o componente nao precisa passar nada a mais; telas com outro
// tipo de arquivo sobrescrevem accept/maxSize e os textos.
const PlanilhaDropzone = ({
    titulo,
    descricao,
    arquivo,
    onSelect,
    onRemove,
    onReject,
    accept = PLANILHA_ACCEPT,
    maxSize = PLANILHA_MAX_SIZE,
    chamada = 'Arraste a planilha aqui',
    legenda = 'XLS, XLSX, CSV ou ODS, até 3 MB',
    // true enquanto onRemove ainda não retornou (ex.: removendo um certificado
    // digital via API - ver pages/agronomos/editCreaV2.js) - troca o "x" por um
    // spinner e desativa o botão, pra não deixar clicar de novo no meio da requisição.
    removendo = false,
}) => {
    const onDrop = useCallback((acceptedFiles, fileRejections) => {
        if (fileRejections && fileRejections.length > 0) {
            const rejeicao = fileRejections[0];
            const motivo = rejeicao.errors.some(err => err.code === 'file-too-large')
                ? 'Arquivo maior que o permitido'
                : 'O arquivo selecionado não possui a extensão correta';
            onReject && onReject(motivo);
            return;
        }

        if (acceptedFiles && acceptedFiles.length > 0) {
            onSelect(acceptedFiles[0]);
        }
    }, [onSelect, onReject]);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept,
        maxSize,
        maxFiles: 1,
        multiple: false,
        disabled: !!arquivo,
    });

    if (arquivo) {
        return (
            <FileCard>
                <FileBadge>{(arquivo.extensao || '').toUpperCase()}</FileBadge>
                <FileInfo>
                    <b>{arquivo.nome}</b>
                    <small>{arquivo.tamanho}</small>
                </FileInfo>
                <RemoveButton type="button" aria-label="Remover arquivo" disabled={removendo} onClick={removendo ? undefined : onRemove}>
                    {removendo ? (
                        <RemoveSpinner />
                    ) : (
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path d="M3 3l8 8M11 3l-8 8" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
                        </svg>
                    )}
                </RemoveButton>
            </FileCard>
        );
    }

    return (
        <DropArea {...getRootProps()} $active={isDragActive}>
            <input {...getInputProps()} />
            <DropIcon>
                <IconUploads width="20px" height="20px" />
            </DropIcon>
            <DropTitle>{chamada} ou <span>selecione um arquivo</span></DropTitle>
            <DropDesc>{descricao}</DropDesc>
            <DropCaption>{legenda}</DropCaption>
        </DropArea>
    );
};

export const formatFileSize = formatSize;

export default PlanilhaDropzone;
